import { forwardRef } from "react";

import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { modeStyle } from "shared/theme/colorMode";

// Native HTML tables and labels keep their original CSS units and DOM semantics.
const ThemedElement = forwardRef(function ThemedElement(
  { component: Component, style, ...props },
  ref
) {
  const { palette } = useTheme();
  return <Component {...props} ref={ref} style={modeStyle(style, palette)} />;
});
ThemedElement.propTypes = {
  component: PropTypes.string.isRequired,
  style: PropTypes.object,
};
export default ThemedElement;
